import PageHeader from "@/components/PageHeader";

const Simple = ({ eyebrow, title, description, body }) => (
  <div>
    <PageHeader
      eyebrow={eyebrow}
      title={title}
      description={description}
      breadcrumb={[{ label: "Home", to: "/" }, { label: eyebrow }]}
    />
    <section className="py-20 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        {body}
      </div>
    </section>
  </div>
);

export const Privacy = () => (
  <Simple
    eyebrow="Privacy Policy"
    title="Your data, respected."
    description="How Akyvia collects, uses and safeguards your information."
    body={
      <div data-testid="privacy-page" className="space-y-6 text-slate-600 leading-relaxed">
        <p>
          Akyvia Sciences and Technologies is committed to protecting your privacy.
          This policy describes what information we collect, how we use it and the
          choices you have regarding your data.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">Information we collect</h3>
        <p>
          We collect only what's necessary to respond to your enquiries and to
          provide the services you've requested — for example, name, email,
          phone, company, and message content.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">How we use it</h3>
        <p>
          Your information is used solely to respond to enquiries, process
          training applications, deliver newsletters and improve our website.
          We do not sell your data to third parties.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">Contact</h3>
        <p>Email <a className="text-sky-600" href="mailto:contact@akyvia.com">contact@akyvia.com</a> for any privacy request.</p>
      </div>
    }
  />
);

export const Terms = () => (
  <Simple
    eyebrow="Terms & Conditions"
    title="Terms of use."
    description="Please read these terms carefully before using this website."
    body={
      <div data-testid="terms-page" className="space-y-6 text-slate-600 leading-relaxed">
        <p>
          By accessing this website you agree to be bound by these terms and
          conditions and applicable laws.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">Intellectual Property</h3>
        <p>
          All content, product names, logos and brands on this website are the
          property of Akyvia Sciences and Technologies Private Limited unless
          otherwise stated.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">Use of Services</h3>
        <p>
          Product enquiries, training applications and career submissions are
          subject to our internal review. Submitting the form does not create a
          binding commitment on either party.
        </p>
        <h3 className="font-display text-xl text-[#0B1B3D]">Contact</h3>
        <p>
          Questions about these terms can be sent to <a className="text-sky-600" href="mailto:contact@akyvia.com">contact@akyvia.com</a>.
        </p>
      </div>
    }
  />
);
